import { render, staticRenderFns } from "./SalesInquiry.vue?vue&type=template&id=793c5f83&scoped=true"
import script from "./SalesInquiry.vue?vue&type=script&lang=js"
export * from "./SalesInquiry.vue?vue&type=script&lang=js"
import style0 from "./SalesInquiry.vue?vue&type=style&index=0&id=793c5f83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793c5f83",
  null
  
)

export default component.exports